import React, { useState, useEffect } from "react";
import { Grid, Box, Typography, Divider, Card, CardMedia } from "@mui/material";
import {
  IOptions,
  SelectInterface,
  ISelectOption,
} from "../../models/BoatOrdering";
import BoatCardComponent from "../../features/boatOrdering/BoatCardComponent";
import UIWidget from "./UIWidget";
import { apiStore } from "../../api/ApiFactory";
import SelectDropdown from "../../components/select/SelectDropdown";
import {
  getLookupsDetails,
  getMotor,
} from "../../store/slices/BoatOrdering/BoatOrderingSelector";
import { useSelector } from "react-redux";
import { calculatePriceByType, reactNumber } from "../../helpers/utils/utils";
import MainModal from "../modal/MainModal";

interface IComponentProps {
  priceType: string;
  isView: boolean;
  currentOptions?: IOptions[];
  stepHeading: String;
  salePriceMarkupOption?: any;
  selectedModel: any;
  msrp: number;
  salePriceMarkupMotor?: any;
}

const StepComponent = ({
  priceType,
  currentOptions,
  stepHeading,
  isView,
  salePriceMarkupOption,
  selectedModel,
  msrp,
  salePriceMarkupMotor,
}: IComponentProps) => {
  const handleUpdateSelectedModal = (val: any, optionIdx: number) => {
    apiStore.boatOrderingApi.updateSelectedModal({
      val,
      optionIdx,
    });
  };

  const MotorSelect: SelectInterface = {
    label: selectedModel.isMotorRequired ? "Motor" : "Motor (Optional)",
    size: "small",
    name: "motor",
  };

  const lookups = useSelector(getLookupsDetails);
  const motor = useSelector(getMotor);

  const [motorOption, setMotorOptions] = useState<ISelectOption[]>([]);

  const [preview, setPreviewImage] = useState(false);
  const [mediaUrl, setMediaUrl] = useState("");

  const previewImage = (mediaUrl: string): void => {
    setPreviewImage(true);
    setMediaUrl(mediaUrl);
  };

  const cancelPreviewImage = () => {
    setPreviewImage(false);
    setMediaUrl("");
  };

  useEffect(() => {
    if (lookups?.motorList) {
      let list: any[] = [];
      lookups?.motorList?.forEach((item: any) => {

        const price: any = calculatePriceByType(
          item.price,
          priceType,
          priceType == "msrp" ? msrp : salePriceMarkupMotor
        );

        const name = `${item.name} ($${reactNumber(price)})`;

        list.push({
          key: item?.partNumber,
          value: name,
          preRigs: item?.preRigs[0]?.value,
          seriesMotors: item?.seriesMotors,
        });

      });

      const preRigOption: any = currentOptions?.filter(
        (option: any) => option.name === "Pre-Rigs"
      );

      const selectedPreRig: any = preRigOption[0]?.choices?.find(
        (preRig: any) => preRig.preSelected && preRig.importKey.toLowerCase().includes("rdo")
      );

      const filterList: any[] = list?.filter(
        (el) =>
          el?.preRigs === selectedPreRig?.value &&
          (el.seriesMotors.length === 0 ||
            el.seriesMotors.some(
              (sm: any) => sm.id === selectedModel.seriesId
            ) === true)
      );

      filterList.unshift({ key: "", value: "Select" });

      setMotorOptions(filterList);
    }
  }, [lookups, priceType, currentOptions]);

  return (
    <>
      <MainModal
        open={preview}
        handleClose={cancelPreviewImage}
        customStyle={{ maxWidth: "600px", px: 0, py: 0 }}
        className="modal-container modal-no-padding"
      >
        <Grid
          item
          xs={12}
          sx={{ justifyContent: "space-around", display: "flex" }}
        >
          <Card
            sx={{ boxShadow: "auto", alignItems: "center" }}
            className="image-perspective"
          >
            <CardMedia component="img" image={mediaUrl} />
          </Card>
        </Grid>
      </MainModal>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className="step-active-wrapper"
      >
        <Grid item lg={6} md={12} xs={12}>
          <BoatCardComponent />
        </Grid>
        <Grid item lg={5} md={12} xs={12} sx={{ mb: 2 }}>
          <Box className="checkbox-list">
            <div className="list-head">
              <h4>{stepHeading}</h4>
            </div>
            {currentOptions &&
              Object.values(currentOptions)?.map(
                (option: any, index: number) => {
                  return (
                    <Box className="checkbox-list" key={index}>
                      <ul>
                        <Typography
                          variant="body1"
                          sx={{ my: 1, px: 1, color: "#000" }}
                          className="furnishingControlLabel"
                        >
                          {option?.name}
                        </Typography>
                        <Divider />
                        <UIWidget
                          salePriceMarkupOption={salePriceMarkupOption}
                          priceType={priceType}
                          isView={isView}
                          checkBoxData={option?.choices}
                          onImagePreview={(mediaUrl) => previewImage(mediaUrl)}
                          onChange={(id) => {
                            handleUpdateSelectedModal(id, index);
                          }}
                          uiWidget={option?.uiWidget}
                          optionName={option?.name}
                          msrp={msrp}
                        />
                      </ul>
                    </Box>
                  );
                }
              )}

            {stepHeading === "Pre-Rig / Motors" && (
              <div className="form-group">
                <SelectDropdown
                  selectData={MotorSelect}
                  options={motorOption}
                  handleChange={(e: any) =>
                    apiStore.boatOrderingApi.setMotor(e.target.value)
                  }
                  disabled={isView}
                  value={motor?.partNumber}
                />
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default StepComponent;
